import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '@/components/common/Select/Select';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  releaseTypes: any[];
  loadReleaseTypes: (inputText: string | null, callback: any) => void;
  handleReleaseType: (value: any) => void;
};

export default function ReleaseTypeFormGroup({
  album,
  readonly,
  disabled,
  releaseTypes,
  loadReleaseTypes,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleReleaseType,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      {!!releaseTypes?.length && (
        <Select
          id="releaseTypeTypeahead"
          labelTitle={t('product.editProduct.releaseType')}
          labelClass="col-sm-3 form-label"
          isClearable={!readonly}
          loadOptions={loadReleaseTypes}
          placeholder=""
          onChange={(e: any) => {
            handleReleaseType(e);
          }}
          initialOption={releaseTypes?.find(
            (rt) => rt.label === album.albumMetaData?.releaseType
          )}
          className="col-sm-6"
          isDisabled={disabled}
          isReadOnly={readonly}
          hasErrors={fieldHasErrors('ReleaseType')}
          errorMessage={findErrorMessage('ReleaseType')}
          isRequired={true}
          showValidationErrors={showValidationErrors}
          fieldValidationKey={'productEditMode.ReleaseType'}
        ></Select>
      )}
    </div>
  );
}
